<div class="adoption-detail-page">

    @if (isLoading) {
  
      <div class="adoption-loading">
        <p>Cargando adopción...</p>
      </div>
  
    } @else if (!adoption) {
  
      <div class="empty-state">
        <div class="empty-icon">🐾</div>
  
        <h2>Adopción no encontrada</h2>
  
        <p>
          No fue posible encontrar la adopción solicitada.
        </p>
  
        <button
          type="button"
          class="back-button"
          (click)="goBack()"
        >
          Volver a adopciones
        </button>
      </div>
  
    } @else {
  
      <!-- =========================
           HEADER
      ========================== -->
  
      <div class="detail-header">
  
        <button
          type="button"
          class="back-button"
          (click)="goBack()"
        >
          ← Volver a adopciones
        </button>
  
        <div class="header-content">
  
          <div>
            <h1>{{ adoption.animalName }}</h1>
  
            <p>
              Proceso de adopción
            </p>
          </div>
  
          <span class="species-badge">
            {{ adoption.species === 'DOG' ? 'Perro' : 'Gato' }}
          </span>
  
        </div>
  
      </div>
  
      <!-- =========================
           ANIMAL
      ========================== -->
  
      <section class="detail-section">
  
        <div class="section-title">
          <h2>Información del animal</h2>
        </div>
  
        <div class="animal-profile">
  
          <div class="animal-photo">
  
            @if (adoption.animalPhotoUrl) {
  
              <img
                [src]="adoption.animalPhotoUrl"
                [alt]="adoption.animalName"
              />
  
            } @else {
  
              <div class="animal-placeholder">
                🐾
              </div>
  
            }
  
          </div>
  
          <div class="animal-information">
  
            <h3>{{ adoption.animalName }}</h3>
  
            <div class="information-grid">
  
              <div class="information-item">
                <span>Especie</span>
                <strong>
                  {{ adoption.species === 'DOG' ? 'Perro' : 'Gato' }}
                </strong>
              </div>
  
              <div class="information-item">
                <span>Género</span>
                <strong>
                  {{ adoption.animalGender || 'No especificado' }}
                </strong>
              </div>
  
              <div class="information-item">
                <span>Raza</span>
                <strong>
                  {{ adoption.breed || 'No especificada' }}
                </strong>
              </div>
  
              <div class="information-item">
                <span>Tamaño</span>
                <strong>
                  {{ adoption.size || 'No especificado' }}
                </strong>
              </div>
  
              <div class="information-item">
                <span>Edad</span>
                <strong>
                  @if (
                    adoption.animalAge !== null &&
                    adoption.animalAge !== undefined
                  ) {
                    {{ adoption.animalAge }} años
                  } @else {
                    No especificada
                  }
                </strong>
              </div>
  
              <div class="information-item">
                <span>Peso</span>
                <strong>
                  @if (
                    adoption.weight !== null &&
                    adoption.weight !== undefined
                  ) {
                    {{ adoption.weight }} kg
                  } @else {
                    No especificado
                  }
                </strong>
              </div>
  
            </div>
  
          </div>
  
        </div>
  
      </section>
  
      <!-- =========================
           RESPONSABLE
      ========================== -->
  
      <section class="detail-section">
  
        <div class="section-title">
          <h2>Información del responsable</h2>
        </div>
  
        <div class="information-grid">
  
          <div class="information-item">
            <span>Nombre</span>
            <strong>
              {{ adoption.responsibleName }}
            </strong>
          </div>
  
          <div class="information-item">
            <span>Edad</span>
            <strong>
              @if (
                adoption.responsibleAge !== null &&
                adoption.responsibleAge !== undefined
              ) {
                {{ adoption.responsibleAge }} años
              } @else {
                No especificada
              }
            </strong>
          </div>
  
          <div class="information-item">
            <span>Género</span>
            <strong>
              {{ adoption.responsibleGender || 'No especificado' }}
            </strong>
          </div>
  
          <div class="information-item">
            <span>Correo electrónico</span>
            <strong>
              {{ adoption.email || 'No especificado' }}
            </strong>
          </div>
  
          <div class="information-item">
            <span>Teléfono</span>
            <strong>
              {{ adoption.phone || 'No especificado' }}
            </strong>
          </div>
  
          <div class="information-item">
            <span>Municipio</span>
            <strong>
              {{ adoption.municipality || 'No especificado' }}
            </strong>
          </div>
  
          <div class="information-item">
            <span>Colonia</span>
            <strong>
              {{ adoption.neighborhood || 'No especificada' }}
            </strong>
          </div>
  
          <div class="information-item">
            <span>Calle y número</span>
            <strong>
              {{ adoption.street || 'No especificado' }}
            </strong>
          </div>
  
          <div class="information-item">
            <span>Cuota de recuperación</span>
            <strong>
              ${{ adoption.recoveryFee || 0 }}
            </strong>
          </div>
  
        </div>
  
      </section>
  
      <!-- =========================
           ABAQ Y REDES
      ========================== -->
  
      <section class="detail-section">
  
        <div class="section-title">
          <h2>Información de ABAQ</h2>
        </div>
  
        <div class="information-grid">
  
          <div class="information-item">
            <span>Cómo se enteró de ABAQ</span>
            <strong>
              {{ adoption.howDidYouHearAboutAbaq || 'No especificado' }}
            </strong>
          </div>
  
          <div class="information-item">
            <span>Red social</span>
            <strong>
              {{ adoption.socialNetwork || 'No especificada' }}
            </strong>
          </div>
  
          <div class="information-item">
            <span>Cuenta</span>
            <strong>
              {{ adoption.socialAccount || 'No especificada' }}
            </strong>
          </div>
  
          <div class="information-item">
            <span>Recomendó a ABAQ</span>
            <strong>
              {{ adoption.recommendedAbaqOnSocialMedia ? 'Sí' : 'No' }}
            </strong>
          </div>
  
        </div>
  
      </section>
  
      <!-- =========================
           PROCESO DE ADOPCIÓN
      ========================== -->
  
      <section class="detail-section">
  
        <div class="section-title">
          <h2>Proceso de adopción</h2>
        </div>
  
        <div class="process-grid">
  
          <div class="process-card">
  
            <span class="process-label">
              Periodo de prueba
            </span>
  
            <div class="information-grid">
  
              <div class="information-item">
                <span>Fecha de inicio</span>
  
                <strong>
                  @if (adoption.trialStartDate) {
                    {{ adoption.trialStartDate | date:'mediumDate':'UTC' }}
                  } @else {
                    No registrada
                  }
                </strong>
              </div>
  
            </div>
  
            <div class="comment-block">
  
              <span>Comentarios</span>
  
              <p>
                {{ adoption.trialComments || 'Sin comentarios' }}
              </p>
  
            </div>
  
          </div>
  
          <div class="process-card">

            <span class="process-label">
              Adopción definitiva
            </span>
          
            @if (adoption.definitiveStartDate) {
          
              <div class="information-grid">
          
                <div class="information-item">
                  <span>Fecha de inicio</span>
          
                  <strong>
                    {{ adoption.definitiveStartDate | date:'mediumDate':'UTC' }}
                  </strong>
                </div>
          
              </div>
          
              <div class="comment-block">
          
                <span>Comentarios</span>
          
                <p>
                  {{ adoption.definitiveComments || 'Sin comentarios' }}
                </p>
          
              </div>
          
              <div class="completed-badge">
                ✓ Adopción completada
              </div>
          
            } @else {

                <p class="pending-message">
                  La adopción todavía no ha sido completada de forma definitiva.
                </p>
              
                @if (!showCompleteForm) {
              
                  <button
                    type="button"
                    class="complete-adoption-button"
                    (click)="openCompleteForm()"
                  >
                    Completar adopción
                  </button>
              
                } @else {
              
                  <div class="complete-adoption-form">
              
                    <div class="form-group">
                      <label for="definitiveStartDate">
                        Fecha de inicio definitivo
                      </label>
              
                      <input
                        id="definitiveStartDate"
                        type="date"
                        [value]="definitiveStartDate"
                        (input)="definitiveStartDate = $any($event.target).value"
                      />
                    </div>
              
                    <div class="form-group">
                      <label for="definitiveComments">
                        Comentarios
                      </label>
              
                      <textarea
                        id="definitiveComments"
                        rows="4"
                        placeholder="Agrega comentarios sobre la adopción definitiva..."
                        [value]="definitiveComments"
                        (input)="definitiveComments = $any($event.target).value"
                      ></textarea>
                    </div>
              
                    <div class="complete-form-actions">
              
                      <button
                        type="button"
                        class="cancel-complete-button"
                        (click)="closeCompleteForm()"
                        [disabled]="isCompletingAdoption"
                      >
                        Cancelar
                      </button>
              
                      <button
                        type="button"
                        class="confirm-complete-button"
                        (click)="completeAdoption()"
                        [disabled]="
                          !definitiveStartDate ||
                          isCompletingAdoption
                        "
                      >
                        @if (isCompletingAdoption) {
                          Completando...
                        } @else {
                          Confirmar adopción
                        }
                      </button>
              
                    </div>
              
                  </div>
              
                }
              
              }
          
          </div>
  
        </div>
  
      </section>
  
      <!-- =========================
           DOCUMENTO
      ========================== -->
  
      <section class="detail-section">
  
        <div class="section-title">
          <h2>Documentación</h2>
        </div>
  
        @if (adoption.formatUrl) {
  
          <a
            [href]="adoption.formatUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="document-link"
          >
            🔗 Ver formato de adopción
          </a>
  
        } @else {
  
          <p class="no-document">
            No hay formato adjunto.
          </p>
  
        }
  
      </section>
  
    }
  
  </div>